import { render } from "./StatsBar.vue?vue&type=template&id=62352248"
import script from "./StatsBar.vue?vue&type=script&lang=js"
export * from "./StatsBar.vue?vue&type=script&lang=js"

import "./StatsBar.vue?vue&type=style&index=0&id=62352248&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__